
$('.resultcard__items').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      }
    }
  ]
});
$('.ingredients__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.ingredients__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// main product js start here 

$('.main-product__big-items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.main-product__small-items'
});

$('.main-product__small-items').slick({
  slidesToShow: 6, 
  slidesToScroll: 1,
  asNavFor: '.main-product__big-items',
  dots: false,
  centerMode: false,
  arrows: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 4
      }
    }
  ]
});



$('.main-product__small-left-arrow').click(function () {
    $(this).parent().find('.slick-slider').slick('slickPrev');
});
$('.main-product__small-right-arrow').click(function () {
    $(this).parent().find('.slick-slider').slick('slickNext');
});


//main product js start here 

$('.product__big').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product__small-items'
});

$('.product__small-items').slick({
  slidesToShow: 6, // default fallback
  slidesToScroll: 1,
  asNavFor: '.product__big',
  dots: false,
  centerMode: false,
  arrows: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 4
      }
    }
  ]
});


$('.product__small-left-arrow').click(function () {
    $(this).parent().find('.slick-slider').slick('slickPrev');
});
$('.product__small-right-arrow').click(function () {
    $(this).parent().find('.slick-slider').slick('slickNext');
});

// product js end here 



// faq start



$(".faq__title , .product__dropdown-title , .product__purchase-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq__content , .product__dropdown-content , .product__purchase-content").slideUp();
    } else {
        $(".faq__content , .product__dropdown-content , .product__purchase-content").slideUp();
        $(".faq__title , .product__dropdown-title , .product__purchase-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq__content , .product__dropdown-content , .product__purchase-content").slideDown();
    }
})




// faq end




$('a[href*="#shopNow"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 1000, 'linear');
});

// -----------------review-card start-------------



if ($(Window).width() < 768) {
    $('.review-card__items').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });
}




$('.review-card__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review-card__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



$(".review-card__item-img").click(function () {
    var video = $(this).find("video").get(0);
    var icon_image = $(this).find(".review-card__video-play-icon");
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".review-card__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});
$(".review-card__video-play-icon").click(function (e) {
    e.stopPropagation();
    var video = $(this).parent().find("video").get(0);
    var icon_image = $(this);
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".review-card__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});





// -----------------review-card end-------------



$(document).ready(function() {
    $(".text-video__img-right").on("click", function() {
        $(".text-video__modal").show();
        $("body").addClass("open-video-modal");
    });
});






$(".text-video__close").on("click", function () {
    $("body").removeClass("open-video-modal");
    $(".text-video__modal").hide();

    // Stop the YouTube video by resetting the iframe src
    var $iframe = $(".text-video__modal iframe");
    var src = $iframe.attr("src");
    $iframe.attr("src", src); // this reloads the iframe and stops the video
});









  document.addEventListener('DOMContentLoaded', function () {
    const discountDisplay = document.getElementById('variant-discount');
    const radios = document.querySelectorAll('input[type="radio"]');

    function updateDiscount() {
      const selected = document.querySelector('input[type="radio"]:checked');
      
      if (selected) {
        const discount = selected.getAttribute('data-discount');
        if (discount && discount > 0) {
          discountDisplay.textContent = `& ÉCONOMISEZ ${discount}%`;

        } else {
          discountDisplay.textContent = ''; // Or 'No discount'
        }
      }
    }


    // Update on change
    radios.forEach(radio => {
      radio.addEventListener('change', updateDiscount);
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    const discountDisplay = document.getElementById('featured_variant-discount');
    const radios = document.querySelectorAll('.product__variant-item input[type="radio"]');

    function updateDiscount() {
      const selected = document.querySelector('.product__variant-item input[type="radio"]:checked');
      
      if (selected) {
        const discount = selected.getAttribute('data-discount');
        if (discount && discount > 0) {
          discountDisplay.textContent = `& ÉCONOMISEZ ${discount}%`;

        } else {
          discountDisplay.textContent = ''; // Or 'No discount'
        }
      }
    }


    // Update on change
    radios.forEach(radio => {
      radio.addEventListener('change', updateDiscount);
    });
  });










  function cartDrawerOpen(e) {
  e.preventDefault();

  $("body").addClass("open-cart-drawer");
}
  function cartDrawerHide(e) {
  e.preventDefault();

  $("body").removeClass("open-cart-drawer");
}



$(".cart-drawer-overlay").on("click",function(){
  $("body").removeClass("open-cart-drawer");
})





  // document.addEventListener("DOMContentLoaded", function () {
  //   const timerContainer = document.querySelector('.sidecart-timer-container');
  //   if (!timerContainer) return;

  //   const startDateAttr = timerContainer.getAttribute('data-start-date');
  //   const finishDateAttr = timerContainer.getAttribute('data-finish-date');

  //   // Parse start and finish dates
  //   const startDate = new Date(startDateAttr.replace(/-/g, '/'));
  //   const finishDate = new Date(finishDateAttr.replace(/-/g, '/'));
  //   const now = new Date();

  //   // If the current date is before the start date, don't show the countdown
  //   if (now < startDate) {
  //     timerContainer.style.display = 'none';
  //     return;
  //   }

  //   function updateCountdown() {
  //     const now = new Date();
  //     const timeLeft = finishDate - now;

  //     if (timeLeft <= 0) {
  //       // Countdown over
  //       document.querySelector('.sidecart-timer-container__timer--days-amount').textContent = '00';
  //       document.querySelector('.sidecart-timer-container__timer--hours-amount').textContent = '00';
  //       document.querySelector('.sidecart-timer-container__timer--minutes-amount').textContent = '00';
  //       document.querySelector('.sidecart-timer-container__timer--seconds-amount').textContent = '00';
  //       clearInterval(timerInterval);
  //       return;
  //     }

  //     const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  //     const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  //     const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
  //     const seconds = Math.floor((timeLeft / 1000) % 60);

  //     document.querySelector('.sidecart-timer-container__timer--days-amount').textContent = String(days).padStart(2, '0');
  //     document.querySelector('.sidecart-timer-container__timer--hours-amount').textContent = String(hours).padStart(2, '0');
  //     document.querySelector('.sidecart-timer-container__timer--minutes-amount').textContent = String(minutes).padStart(2, '0');
  //     document.querySelector('.sidecart-timer-container__timer--seconds-amount').textContent = String(seconds).padStart(2, '0');
  //   }

  //   updateCountdown(); // Initial call
  //   const timerInterval = setInterval(updateCountdown, 1000);
  // });



  
// custom review section js start here 

// $(document).ready(function () {






$(".custom-review__faq-item-title,.ingredients__item-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".custom-review__faq-item-content-wrap, .ingredients__item-content").slideUp();
    } else {
        $(".custom-review__faq-item-content-wrap, .ingredients__item-content").slideUp();
        $(".custom-review__faq-item-title, .ingredients__item-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".custom-review__faq-item-content-wrap, .ingredients__item-content").slideDown();
    }
})



$(".custom-review__faq-item-read-more").on("click", function (e) {
  e.preventDefault(); 
$("body").addClass("open-review-modal");
  var dataId = $(this).attr("data-modal-id");
  var $modal = $(".custom-review__modal#" + dataId); 

  $(".custom-review__modal").hide();

  $modal.show();
});


$(".ovarlay, .custom-review__modal-top p").on("click",function(){
  $("body").removeClass("open-review-modal");
  $(".custom-review__modal").hide();
})




// })


// custom review section js start here 






// $(document).ready(function () {


  if ($(window).width() > 768) {
  var $slider = $('.poweredby__item-card-items');
  
  $slider.on('init', function (event, slick) {
    $('#total').text(slick.slideCount); // Total individual slides
    $('#current').text(1); // Start with slide 1
  });
  
  $slider.on('afterChange', function (event, slick, currentSlide) {
    // Cap current slide number to total (e.g. on last slide)
    let current = currentSlide + 1;
    if (current > slick.slideCount) current = slick.slideCount;
    $('#current').text(current);
  });
  
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false
  });
 

}

//  });


// Arrow controls
$('.arrow__count-left').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});

$('.arrow__count-right').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



$(window).on('scroll', function () {
  if ($(this).scrollTop() >= 1200) {
    $('.sticky__btn-wrap').fadeIn(); 
  } else {
    $('.sticky__btn-wrap').fadeOut(); 
  }
});




